import React, { VFC } from "react";

export const UnknownMessage: VFC = () => <></>;
